module.exports = __webpack_public_path__ + "img/qrcode_258.7a480c76.jpg";